<template>
  <div>
    <div v-for="spaceInfo in spaceList"
         ref="spaceRefs">
      <SpaceInfoPanel :space-info="spaceInfo"
                      :search-rent-type="rentTimeSelected.rent_type"></SpaceInfoPanel>
    </div>
    <div v-if="total>pageLimit"
         class="h-[80px] flex items-center justify-center">
      <el-pagination :background="true"
                     hide-on-single-page
                     class="space-pagination"
                     :current-page="currentPage"
                     @current-change="handlePaginationChange"
                     layout="prev, pager, next"
                     :page-size="pageLimit"
                     :pager-count="4"
                     :total="total"/>
    </div>
  </div>
</template>
<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import {useSearchQueryStore} from "@/stores/searchQuery";
import {useSearchResultStore} from "@/stores/searchResult";
import SpaceInfoPanel from "./SpaceInfoPanel.vue";
import {useRoute, useRouter} from "nuxt/app";
import {useSearchWithStore} from "@/composables/useSearchWithStore";


const router = useRouter()
const route = useRoute();
const {handleSearchWithStore} = useSearchWithStore()
const searchQueryStore = useSearchQueryStore();
const searchResultStore = useSearchResultStore()

const spaceList = computed(() => searchResultStore.getSpaceList);
const total = computed(() => searchResultStore.getSpaceListTotal);
const requestId = computed(() => searchResultStore.getRequestId);
const pageLimit = computed(() => searchQueryStore.getPagination.limit);
const routeSid = computed(() => route.query.msid)
const routeSlideTo = computed(() => route.query.slideTo)
const spaceRefs = ref([])
const currentPage = ref(searchQueryStore.getPagination.page)

const rentTimeSelected = computed(() => searchQueryStore.getRentTimeSelected)

onMounted(() => {
  if (route.query.msid) {
    const index = spaceList.value.findIndex((item) => item.space_id === parseInt(routeSid.value));
    slideTo(index)
  }
  currentPage.value = searchQueryStore.getPagination.page

})


// 連動網址 msid 移動到對應的空間
watch(() => routeSlideTo.value, () => {

  if (routeSlideTo.value) {
    const index = spaceList.value.findIndex((item) => item.space_id === parseInt(routeSid.value));
    slideTo(index)
    router.push({query: {...route.query, 'slideTo': undefined}})
  }
})

/*watch(() => searchQueryStore.pagination, (newPagination,oldPagination) => {
  currentPage.value = newPagination.page
}, {
  deep: true,
  immediate: false
});*/

function slideTo(index) {
  nextTick(() => {
    spaceRefs.value[index].scrollIntoView();
  })
}

function handlePaginationChange(page) {
  currentPage.value = page
  searchQueryStore.setRequestId(requestId.value)
  searchQueryStore.setPagination({page: page})
  router.push({query: null})
  handleSearchWithStore()
  spaceRefs.value[0].scrollIntoView();

}

</script>

<style scoped
       lang="scss">
@tailwind components;
@layer components {
  .space-list-pagination {
    @apply w-[40px] h-[40px] text-[18px] font-bold border-2 border-solid border-osn-grey-03 bg-osn-white-00 rounded-xl;
  }
}

:deep(.el-pagination) {

  .el-pager li,
  .btn-next,
  .btn-prev {
    @apply space-list-pagination;
  }

  .el-pager li:not(.disabled).is-active {
    @apply bg-osn-white-00 text-osn-dark-grey-00 border-osn-yellow-00;
  }

  .btn-next .el-icon,
  .btn-prev .el-icon {
    @apply w-auto text-[18px] text-osn-dark-grey-00;
  }
}


</style>
